export * from './lib/user-profile.module';
export * from './lib/user-profile/user-profile.component';
